import Main from "../views/phoneHome/main.vue";
import Sign from "../views/phoneHome/sign.vue";
const phoneRouter = [
  {
    path: "/",
    name: "first",
    redirect: "/home",
    component: () => import("@/views/phoneHome/fistPage.vue"),
    meta: { keepAlive: true, isMobile: true },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/phoneHome/home.vue"),
    meta: { keepAlive: true, isMobile: true },
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/phoneHome/error.vue"),
    meta: { keepAlive: false, isMobile: true },
  },
  {
    path: "/export",
    name: "export",
    component: () => import("@/views/phoneBody/exportPDF.vue"),
    meta: { keepAlive: false, isMobile: true },
  },
  {
    path: "/news",
    name: "news",
    component: Main,
    children: [
      {
        path: "detail",
        name: "detail",
        component: () => import("@/views/phoneBody/detail.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "law",
        name: "law",
        component: () => import("@/views/phoneBody/law.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "vipApply",
        name: "vipApply",
        component: () => import("@/views/phoneBody/vipApply.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "alllist",
        name: "alllist",
        component: () => import("@/views/phoneBody/list.vue"),
        meta: { keepAlive: true, isMobile: true },
      },
      {
        path: "tab",
        name: "tab",
        component: () => import("@/views/phoneBody/tab.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "commit",
        name: "commit",
        component: () => import("@/views/phoneBody/commitInfo.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "activelist",
        name: "activelist",
        component: () => import("@/views/phoneBody/activeList.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "activedetail",
        name: "activedetail",
        component: () => import("@/views/phoneBody/activeInfo.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
    ],
  },
  {
    path: "/laboursinfo",
    name: "laboursinfo",
    component: Main,
    children: [
      {
        path: "labourinfo",
        name: "labourinfo",
        component: () => import("@/views/phoneBody/labourinfo.vue"),
        meta: { keepAlive: true, isMobile: true },
      },
    ],
  },
  {
    path: "/more",
    name: "more",
    component: Main,
    children: [
      {
        path: "ispay",
        name: "ispay",
        component: () => import("@/views/phoneBody/isPay.vue"),
        meta: { keepAlive: true, isMobile: true },
      },
      {
        path: "doc",
        name: "doc",
        component: () => import("@/views/phoneBody/card.vue"),
        meta: { keepAlive: true, isMobile: true },
      },
      {
        path: "info",
        name: "info",
        component: () => import("@/views/phoneBody/info.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "labourinfos",
        name: "labourinfos",
        component: () => import("@/views/phoneBody/labourinfos.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "docInfo",
        name: "docInfo",
        component: () => import("@/views/phoneBody/unitInfo.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "photoes",
        name: "photoes",
        component: () => import("@/views/phoneBody/photoes.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      // {
      //     path: 'unitInfos',
      //     name: 'unitInfos',
      //     component: () => import('@/views/phoneBody/unitInfos.vue'),
      //     meta: { keepAlive: false}
      // },
      {
        path: "search",
        name: "search",
        component: () => import("@/views/phoneBody/search.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "workorlearn",
        name: "workorlearn",
        component: () => import("@/views/phoneBody/workorlearn.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "commitdoc",
        name: "commitdoc",
        component: () => import("@/views/phoneBody/commitdoc.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "wlDetail",
        name: "wlDetail",
        component: () => import("@/views/phoneBody/wlDetail.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/phoneBody/feedback.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "mistake",
        name: "mistake",
        component: () => import("@/views/phoneBody/mistake.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
      {
        path: "mistakeInfo",
        name: "mistakeInfo",
        component: () => import("@/views/phoneBody/mistakeInfo.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
    ],
  },
  {
    path: "/signOn",
    name: "signOn",
    component: Sign,
    meta: { isMobile: true },
    children: [
      {
        path: "meeting",
        name: "meeting",
        component: () => import("@/views/phoneBody/SignOnMeet.vue"),
        meta: { keepAlive: false, isMobile: true },
      },
    ],
  },
];

export default phoneRouter;



// WEBPACK FOOTER //
// ./src/router/phone.js